import React, { useEffect, useRef, useState } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import { FaUser, FaEnvelope, FaPhone, FaMapPin } from "react-icons/fa";
import "../CounsellorallEditPages/CounsellorProfileEdit.css";
import {
  getUserById,
  checkCounsellorEmail,
  UpdateCounsellor,
} from "../../api/api";
import { useNavigate } from "react-router-dom";
import { FaInfoCircle } from "react-icons/fa";

const validationSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  email: Yup.string()
    .email("Invalid email format")
    .required("Email is required"),
  phone: Yup.string().required("Phone number is required"),
  role: Yup.string().required("Role is required"),
  dob: Yup.object()
    .shape({
      day: Yup.number()
        .min(1, "Invalid day")
        .max(31, "Invalid day")
        .required("Day is required"),
      month: Yup.number()
        .min(1, "Invalid month")
        .max(12, "Invalid month")
        .required("Month is required"),
      year: Yup.number()
        .min(1900, "Invalid year")
        .max(new Date().getFullYear(), "Invalid year")
        .required("Year is required"),
    })
    .test("valid-date", "Invalid day for the selected month", (value) => {
      if (!value) return false;
      const { day, month, year } = value;
      if (!day || !month || !year) return true;

      const isLeapYear =
        year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
      const daysInMonth = [
        31,
        isLeapYear ? 29 : 28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31,
      ];

      return day <= daysInMonth[month - 1];
    })
    .test("age-limit", "You must be at least 18 years old", (value) => {
      if (!value) return false;
      const { day, month, year } = value;
      if (!day || !month || !year) return false;

      const dob = new Date(year, month - 1, day);
      const today = new Date();
      const ageDiff = today.getFullYear() - dob.getFullYear();
      const monthDiff = today.getMonth() - dob.getMonth();
      const dayDiff = today.getDate() - dob.getDate();

      if (
        ageDiff > 18 ||
        (ageDiff === 18 && (monthDiff > 0 || (monthDiff === 0 && dayDiff >= 0)))
      ) {
        return true;
      }
      return false;
    }),
  address: Yup.string().required("Address is required"),
  // postcode: Yup.string().required("Postcode is required"),
});

const CounsellorProfileEdit = () => {
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const nameRef = useRef(null);
  const emailRef = useRef(null);
  const phoneNumberRef = useRef(null);
  const passwordRef = useRef(null);
  const confirmpasswordRef = useRef(null);
  const ddRef = useRef(null);
  const mmRef = useRef(null);
  const yearRef = useRef(null);
  const professionRef = useRef(null);
  const addressRef = useRef(null);
  const bioRef = useRef(null);
  const roleRef = useRef(null);
  const postcodeRef = useRef(null);

  const [isEmailValid, setIsEmailValid] = useState("");
  const [commingData, setCommingData] = useState(null);

  useEffect(() => {
    const getUserdata = async () => {
      try {
        const userData = localStorage.getItem("currentUser");
        const parsedUserData = JSON.parse(userData);
        const _id = parsedUserData?.id || parsedUserData?._id;

        if (_id) {
          const res = await getUserById({ user_id: _id });
          console.log("getUserById_data", res);
          setCommingData(res?.data);
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };

    getUserdata();
  }, []);

  const handleCustomChange = async (value, setFieldValue) => {
    setFieldValue("email", value.toLowerCase());
    const response = await checkCounsellorEmail({ email: value.toLowerCase() });
    console.log("response", response);
    if (response?.success) {
      console.log("success");
      setIsEmailValid(response?.message);
    } else {
      console.log("error");
      setIsEmailValid(response?.message);
    }
  };

  const handleSubmit = async (values) => {
    console.log("buttonClick11111");
    setIsLoading(true);
    console.log("buttonClick");
    try {
      const { day, month, year } = values.dob;
      const formattedDob = `${year.padStart(4, "0000")}-${month.padStart(
        2,
        "0"
      )}-${day.padStart(2, "0")}`;
      const registerFormData = { ...values, dob: formattedDob };
      console.log("Update_Value", registerFormData);
      const firstPaymentResponse = await UpdateCounsellor(registerFormData);
      console.log("Councellor Update api response", firstPaymentResponse);

      if (firstPaymentResponse?.success === true) {
        alert(
          "Success",
          firstPaymentResponse?.message,
          [
            {
              text: "OK",
              onPress: () => {
                navigate("/profile");
              },
            },
          ],
          { cancelable: false }
        );
      } else {
        alert(
          "",
          firstPaymentResponse.message,
          [
            {
              text: "OK",
              onPress: () => {
                navigate("/CounsellorSidebar/CounsellorEditProfile");
              },
            },
          ],
          { cancelable: false }
        );
      }
      navigate("/CounsellorSidebar/CounsellorEditProfile");
    } catch (error) {
      alert("Error", "Something went wrong");
      console.error("Submit error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="container">
      <div className="EditProfile-scroll">
        <Formik
          enableReinitialize
          initialValues={{
            counsellor_id: commingData?.id || "",
            name: commingData?.name || "",
            email: commingData?.email || "",
            phone: commingData?.phone || "",
            dob: commingData?.dob
              ? {
                  day: commingData.dob.split("-")[2] || "",
                  month: commingData.dob.split("-")[1] || "",
                  year: commingData.dob.split("-")[0] || "",
                }
              : { day: "", month: "", year: "" },
            address: commingData?.address || "",
            bio: commingData?.bio || "",
            role: commingData?.role || "",
            postcode: commingData?.postcode || "",
          }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({
            handleChange,
            handleBlur,
            handleSubmit,
            values,
            errors,
            touched,
            setFieldValue,
          }) => (
            <form onSubmit={handleSubmit}>
              <div className="inputView">
                <FaUser size={20} color="#b2adb4" />
                <input
                  type="text"
                  placeholder="Name"
                  value={values.name}
                  onChange={handleChange("name")}
                  onBlur={handleBlur("name")}
                  className="textInput"
                />
              </div>
              {touched.name && errors.name && (
                <div className="errorText">{errors.name}</div>
              )}
              <div className="inputView">
                <FaEnvelope size={20} color="#b2adb4" />
                <input
                  type="email"
                  placeholder="Email"
                  value={values.email}
                  onChange={handleChange("email")}
                  onBlur={handleBlur("email")}
                  className="textInput"
                  disabled
                />
              </div>
              {touched.email && errors.email && (
                <div className="errorText">{errors.email}</div>
              )}
              <div className="inputView">
                <FaPhone size={20} color="#b2adb4" />
                <input
                  type="text"
                  placeholder="Phone Number"
                  value={values.phone}
                  onChange={handleChange("phone")}
                  onBlur={handleBlur("phone")}
                  className="textInput"
                />
              </div>
              {touched.phone && errors.phone && (
                <div className="errorText">{errors.phone}</div>
              )}
              <div className="inputView">
                <select
                  value={values.role}
                  onChange={(e) => setFieldValue("role", e.target.value)}
                  onBlur={handleBlur("role")}
                  className="textInput"
                >
                  <option value="">Select Role...</option>
                  <option value="connection_curator">Connection Curator</option>
                  <option value="match_making_consultant">
                    Match Making Consultant
                  </option>
                  <option value="relationship_success_coach">
                    Relationship Success Coach
                  </option>
                  <option value="match_success_advisor">
                    Match Success Advisor
                  </option>
                </select>
              </div>
              {touched.role && errors.role && (
                <div className="errorText">{errors.role}</div>
              )}
              <div className="inputView2">
                <input
                  type="text"
                  placeholder="DD"
                  value={values.dob.day}
                  onChange={(e) => {
                    console.log("Setting day:", e.target.value);
                    setFieldValue("dob.day", e.target.value);
                  }}
                  onBlur={handleBlur("dob.day")}
                  className="textInputdob"
                />
                <input
                  type="text"
                  placeholder="MM"
                  value={values.dob.month}
                  onChange={(e) => {
                    console.log("Setting month:", e.target.value);
                    setFieldValue("dob.month", e.target.value);
                  }}
                  onBlur={handleBlur("dob.month")}
                  className="textInputdob"
                />
                <input
                  type="text"
                  placeholder="YYYY"
                  value={values.dob.year}
                  onChange={(e) => {
                    console.log("Setting year:", e.target.value);
                    setFieldValue("dob.year", e.target.value);
                  }}
                  onBlur={handleBlur("dob.year")}
                  className="textInputdob"
                />
              </div>

              {touched.dob?.day && errors.dob?.day && (
                <div className="errorText">{errors.dob.day}</div>
              )}
              {touched.dob?.month && errors.dob?.month && (
                <div className="errorText">{errors.dob.month}</div>
              )}
              {touched.dob?.year && errors.dob?.year && (
                <div className="errorText">{errors.dob.year}</div>
              )}

              <div className="inputView">
                <FaMapPin size={20} color="#b2adb4" />
                <input
                  type="text"
                  placeholder="Address"
                  value={values.address}
                  onChange={handleChange("address")}
                  onBlur={handleBlur("address")}
                  className="textInput"
                />
              </div>
              {touched.address && errors.address && (
                <div className="errorText">{errors.address}</div>
              )}
              <div className="inputView">
                <FaMapPin size={20} color="#b2adb4" />
                <input
                  type="text"
                  placeholder="Post Code"
                  value={values.postcode}
                  onChange={handleChange("postcode")}
                  onBlur={handleBlur("postcode")}
                  className="textInput"
                />
              </div>
              {touched.postcode && errors.postcode && (
                <div className="errorText">{errors.postcode}</div>
              )}
              <div className="inputView">
                <FaInfoCircle size={20} color="#b2adb4" />
                <textarea
                  placeholder="Bio"
                  value={values.bio}
                  onChange={handleChange("bio")}
                  onBlur={handleBlur("bio")}
                  className="textArea"
                  rows={4}
                />
              </div>
              {touched.bio && errors.bio && (
                <div className="errorText">{errors.bio}</div>
              )}
              <button type="submit" className="signupBtn" disabled={isLoading}>
                {isLoading ? (
                  <div>Loading...</div>
                ) : (
                  <span className="signupText">Update</span>
                )}
              </button>
              <button
                type="button"
                className="backButton"
                onClick={() => window.history.back()}
              >
                <span className="backButtonText">Back</span>
              </button>
            </form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default CounsellorProfileEdit;
